<template>
	<div class="video">
		<!-- Placeholder quando i cookie non sono accettati -->
		<div v-if="!hasConsent" class="video-placeholder">
			<div class="placeholder-content">
				<div class="placeholder-icon">▶️</div>
				<p>Per visualizzare questo video è necessario accettare i cookie di funzionalità.</p>
				<a 
					href="https://www.comune.lucca.it/progetti/cookie-policy/" 
					target="_blank"
					class="cookie-link"
				>
					Maggiori informazioni
				</a>
				<button @click="reloadPage" class="accept-btn">
					Accetta e visualizza video
				</button>
			</div>
		</div>

		<!-- Video YouTube quando i cookie sono accettati -->
		<youtube
			v-else-if="
				!block.attributes.providerNameSlug ||
					block.attributes.providerNameSlug === 'youtube'
			"
			width="100%"
			:video-id="getId(block.attributes.url)"
			:player-vars="playerVars"
		></youtube>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	props: ["block", "parentBlock"],
	data() {
		return {
			playerVars: {
				autoplay: 0,
			},
		};
	},
	computed: {
		...mapGetters(['hasCookieConsent']),
		hasConsent() {
			return this.hasCookieConsent('functionality');
		},
		player() {
			return this.$refs.youtube ? this.$refs.youtube.player : null;
		},
	},
	methods: {
		getId(url) {
			return this.$youtube.getIdFromUrl(url);
		},
		reloadPage() {
			// Accetta i cookie functionality e ricarica
			this.$store.dispatch('updateCookieConsent', { 
				type: 'functionality', 
				value: true 
			});
			window.location.reload();
		}
	},
};
</script>

<style lang="scss" scoped>
.video {
	padding-bottom: $spacing-0;
	position: relative;
}

.video-placeholder {
	min-height: 400px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #000;
	border-radius: 4px;
	position: relative;
	
	// Mantiene il rapporto 16:9
	&::before {
		content: '';
		display: block;
		padding-top: 56.25%; // 16:9 aspect ratio
	}
	
	.placeholder-content {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
		padding: 40px 20px;
		max-width: 400px;
		width: 90%;
		
		.placeholder-icon {
			font-size: 64px;
			margin-bottom: 20px;
			opacity: 0.7;
		}
		
		p {
			color: #fff;
			font-size: 16px;
			line-height: 1.5;
			margin: 0 0 15px 0;
		}
		
		.cookie-link {
			display: inline-block;
			color: #fff;
			text-decoration: underline;
			font-size: 14px;
			margin-bottom: 20px;
			opacity: 0.8;
			
			&:hover {
				opacity: 1;
			}
		}
		
		.accept-btn {
			display: block;
			width: 100%;
			padding: 12px 24px;
			background-color: #ff0000;
			color: white;
			border: none;
			border-radius: 4px;
			font-size: 14px;
			font-weight: 600;
			cursor: pointer;
			transition: background-color 0.2s;
			
			&:hover {
				background-color: #cc0000;
			}
		}
	}
}
</style>